module.exports = "input.ng-invalid.ng-touched {\n  border: 1px solid red; }\n\n.form-control {\n  border: 1px solid #7190aac7 !important; }\n\n.table-bordered > tbody > tr > td, .table-bordered > tbody > tr > th, .table-bordered > tfoot > tr > td, .table-bordered > tfoot > tr > th, .table-bordered > thead > tr > td, .table-bordered > thead > tr > th {\n  border: 1px solid #aba7a7 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/check-list-details/check-list-details.component.scss
// module id = ./client/app/check-list-details/check-list-details.component.scss
// module chunks = main